import { defineMessages } from 'react-intl';
import { t } from '../utils/translate';

const translations = defineMessages({
  nearbyLabel: {
    id: 'data.distances.nearbyLabel',
    defaultMessage: 'Dans cette ville',
    description: 'Label de l option pour afficher les pros dans la zone de recherche',
  },
  widenLabel: {
    id: 'data.distances.widenLabel',
    defaultMessage: 'Dans la région',
    description: 'Label de l option pour afficher les pros plus éloigné',
  },
});

export const distanceOptions = [
  {
    value: '',
    label: t(translations.nearbyLabel),
  },
  {
    value: '50km',
    label: t(translations.widenLabel),
  },
];
